// --------------------------------------------------------------
// Created On: 2023-12-11
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./RentingAssetListRow.module.scss";

// A single asset that is being rented by the current company.
export default function RentingAssetListRow(props: Props): Component {
  return (
    <div className="p-2" data-test="rental-list-row">
      <span>Asset &apos;</span>

      <b>{props.name}</b>

      <span>{props.isPendingApproval ? "' is being sent from company '" : "' is rented from company '"}</span>

      <b>{props.renterCompanyName}</b>

      <span>&apos;</span>

      {props.isPendingApproval && (
        <span data-test="pending-rental-marker" className={styles.tag}>
          Pending
        </span>
      )}
    </div>
  );
}

interface Props {
  assetId: number;
  name: string;
  renterCompanyName: string;
  isPendingApproval: boolean;
}
